/** Storage under this prefix belongs to the authenticated session, never to the next login. */
export const AUTH_SESSION_STORAGE_PREFIX = 'luminovo.auth-session.';
let generation = 0;
export function getAuthSessionGeneration(): number {
    return generation;
}
export function clearAuthSessionStorage(): void {
    // Invalidate writers before accessing storage (which can itself throw).
    generation += 1;
    try {
        for (let index = sessionStorage.length - 1; index >= 0; index--) {
            const key = sessionStorage.key(index);
            if (key?.startsWith(AUTH_SESSION_STORAGE_PREFIX)) sessionStorage.removeItem(key);
        }
    } catch {
        // A blocked or unavailable storage must not prevent logout.
    }
}
